import { motion } from 'framer-motion';
import type { Easing } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ease: Easing = 'easeOut';

const reveal = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-40px' },
  transition: { duration: 0.5, ease },
};

const CuradoriaSection = () => {
  const { t } = useTranslation();

  return (
    <section id="curadoria" className="section-padding bg-surface">
      <div className="max-w-[680px] mx-auto text-center">
        <motion.h2 {...reveal} className="text-display text-section text-foreground italic mb-12 md:mb-16 whitespace-pre-line">
          {t('brooklyn.curadoria.title')}
        </motion.h2>

        <div className="space-y-8">
          <motion.p {...reveal} className="text-body-fluid text-muted-foreground leading-relaxed-body">
            {t('brooklyn.curadoria.p1')}
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.5, ease, delay: 0.08 }}
            className="text-body-fluid text-muted-foreground leading-relaxed-body"
          >
            {t('brooklyn.curadoria.p2')}
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.5, ease, delay: 0.16 }}
            className="text-body-fluid text-muted-foreground leading-relaxed-body whitespace-pre-line"
          >
            {t('brooklyn.curadoria.p3')}
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.5, ease, delay: 0.24 }}
          className="mt-12"
        >
          <Link to="/apply" className="btn-outline w-full sm:w-auto">
            {t('brooklyn.curadoria.cta')} →
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CuradoriaSection;
